export default __webpack_public_path__ + "static/media/shopee.9146b4af.png";